import type { ComponentType } from 'react'

import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { cn } from '@/lib/tailwind.utils'

interface UseCaseCardProps {
  title: string
  description: string
  Icon: ComponentType
  accentClassName?: string
  className?: string
  onLearnMore?: () => void
  showBody?: boolean
}

const UseCaseCard = ({
  title,
  description,
  Icon,
  accentClassName = 'bg-deepTeal',
  className,
  onLearnMore,
  showBody = true,
}: UseCaseCardProps) => (
  <Card
    onClick={onLearnMore}
    className={cn(
      'group relative overflow-hidden rounded-2xl border-border bg-card dark:hover:bg-neutral dark:hover:border-neutral-100 max-w-lg transition-colors hover:bg-accent hover:cursor-pointer',
      className,
    )}
  >
    <div className={cn('absolute inset-y-0 left-0 w-3', accentClassName)} />

    <CardContent className="flex flex-col p-4 pl-10">
      <div className="flex items-center gap-4">
        <div
          className={cn(
            'flex h-12 w-12 shrink-0 items-center justify-center rounded-full',
            accentClassName,
          )}
        >
          <Icon />
        </div>

        <h3 className="text-sm font-bold text-foreground">{title}</h3>
      </div>

      {showBody && (
        <>
          <p className="mt-8 max-w-full text-sm leading-snug text-foreground pb-4">{description}</p>

          <div className="mt-auto flex justify-end">
            <Button
              variant="outline"
              size={'sm'}
              onClick={onLearnMore}
              className="transition-all group-hover:bg-secondary/80 group-hover:text-rexBlue-600 dark:group-hover:bg-transparent dark:group-hover:text-neutral-100 "
            >
              Learn more
            </Button>
          </div>
        </>
      )}
    </CardContent>
  </Card>
)

export default UseCaseCard
